import React, { useEffect, useState } from 'react'
import { Space } from 'antd'
import { appConfig } from 'config'
import { MapWithASearchBox } from 'Components/utilities'
import { DetailDrawer } from 'Components/common/MainLayout'
import { PrimaryButton } from 'Components/button'
import styled from 'styled-components'
const MyMapWithASearchBox: any = MapWithASearchBox

type Props = {
  isShow: boolean
  onClose: () => void
  onSave: (lat: number, long: number) => void
  data: any
}

interface LocationState {
  lat: number
  long: number
}

const EditMapDrawer = (props: Props) => {
  const { isShow, onClose, data, onSave = () => {} } = props
  const [location, setLocation] = useState({
    lat: 0,
    long: 0,
  } as LocationState)

  useEffect(() => {
    if (isShow) {
      setLocation({
        lat: data?.lat || 0,
        long: data?.long || 0,
      })
    }
  }, [isShow])

  const footer = (
    <Space size="middle" align="baseline">
      <PrimaryButton text="ยกเลิก" btnType="Cancel" onClick={onClose} />
      <PrimaryButton text="บันทึก" onClick={() => onSave(location.lat, location.long)} />
    </Space>
  )

  return (
    <DetailDrawer
      title="แก้ไขที่ตั้งร้านค้า"
      width={'50%'}
      onCloseDrawer={onClose}
      visible={isShow}
      footer={footer}
      maskClosable={true}
    >
      <MapWrapper>
        <MyMapWithASearchBox
          lat={location.lat}
          long={location.long}
          isMarkerShown
          draggable={true}
          onDragEnd={(lat: number, lng: number) => {
            setLocation({
              lat: lat,
              long: lng,
            })
          }}
          googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${appConfig.googleMapKey}&v=3.exp&libraries=geometry,drawing,places`}
          loadingElement={<div style={{ height: `100%` }} />}
          containerElement={<div style={{ height: `60vh` }} />}
          mapElement={<div style={{ height: `100%` }} />}
        />
      </MapWrapper>
    </DetailDrawer>
  )
}

const MapWrapper = styled.div`
  padding: 10px 0;
  .gmnoprint {
    bottom: 12px;
    top: auto !important;
  }
  .ant-input-affix-wrapper {
    margin: 1%;
    //width: 80% !important;
  }
`

export default EditMapDrawer
